import { memo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Button, Modal } from 'rsuite';
import { RootState } from '../@types/RootState';
import { selectorNavBarModals, SET_IS_OPEN } from '../reducers/navBar/modals';

type NoAssociationModalProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const NoAssociationModal = ({ onHide, show, administradores }: NoAssociationModalProps) => {
  return (
    <Modal size="md" show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Usuário sem acesso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você não possui acesso a este produto da InfoPrice. Entre em contato com o administrador da sua conta, {administradores ? administradores[0] : null},
          ou com o gerente de conta responsável.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} appearance="subtle">
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  show: selectorNavBarModals(state).none,
  administradores: state.adminDataReducer.administradores,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(SET_IS_OPEN({ key: 'none', payload: false })),
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(NoAssociationModal));
